import { DynamicService } from 'utils/service';

import {
  API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITIES,
  CreateBulkUserPatientProfileSessionSensitivityInput,
  UserPatientProfileSessionSensitivity,
} from './models';

export * from './models';

class Service extends DynamicService<UserPatientProfileSessionSensitivity> {
  createBulk = (input: CreateBulkUserPatientProfileSessionSensitivityInput) => {
    return this.engine.post(API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITIES.POST_BULK, {
      mainID: input.userPatientProfileSessionID,
      itemIDs: input.sensitivityIDs,
    });
  };
}

export const ServiceUserPatientProfileSessionsSensitivities = new Service({
  mainField: 'id',
  getAll: API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITIES.GET_ALL_DYNAMIC,
  post: API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITIES.POST,
  delete: API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITIES.DELETE,
  patch: API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITIES.PATCH,
});
